import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { State, POINTER_HOVER_SELECTOR } from '../../../util/interactiveState.js';
import { selectToken } from '../../../util/tokenSelector.js';
import toRgbColor from '../../../util/toRgbColor.js';
import { IconStyled } from '../../Icon/Icon.styled.js';
import { TypographyStyled } from '../../Typography/Typography.styled.js';
import { ICON_CONTAINER_CLASS } from './constants.js';
import { LabelStyled, InputTypographyStyled } from './FormField.styled.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var inputInteractiveState = function inputInteractiveState(experiments, theme, interactive) {
  var primaryColor = selectToken(theme.background, 'product.primary');
  var legendColor = selectToken(theme.text, 'base.subtle');
  if (!primaryColor) return null;
  var color = toRgbColor(primaryColor);
  var hover = "rgba(".concat(color.red, ", ").concat(color.green, ", ").concat(color.blue, ", 0.08)");
  var inputAction = '.ads-input-action';
  return _objectSpread(_defineProperty({}, "&".concat(State.FocusedWithin), _defineProperty(_defineProperty(_defineProperty({}, "& ".concat(LabelStyled), _objectSpread({
    opacity: 0,
    transition: 'opacity 0.3s'
  }, interactive && {
    '& > p': {
      color: primaryColor
    }
  })), '& fieldset', _objectSpread(_objectSpread({}, interactive && {
    borderColor: primaryColor
  }), {}, {
    '& > legend': {
      maxWidth: '100%',
      transition: 'max-width 0.3s',
      '& > span': _objectSpread({
        opacity: 1,
        transition: 'opacity 0.3s, color 0.3s'
      }, interactive && {
        color: primaryColor
      })
    }
  })), '> span', {
    color: legendColor
  })), interactive && _defineProperty(_defineProperty(_defineProperty({}, "".concat(POINTER_HOVER_SELECTOR), _defineProperty(_defineProperty({}, "&".concat(State.Hover), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    '& fieldset': {
      borderColor: primaryColor,
      background: hover,
      '& > legend > span': {
        color: primaryColor
      }
    }
  }, "& ".concat(LabelStyled, " > ").concat(TypographyStyled), {
    color: primaryColor
  }), "& ".concat(LabelStyled, " p"), {
    color: primaryColor
  }), experiments.iconsMigrationToV3 ? "& button > .".concat(ICON_CONTAINER_CLASS, ":not(").concat(inputAction, "), [role=presentation] > .").concat(ICON_CONTAINER_CLASS, ":not(").concat(inputAction, ")") : "& button > ".concat(IconStyled, ":not(").concat(inputAction, "), [role=presentation] > ").concat(IconStyled, ":not(").concat(inputAction, ")"), {
    fill: primaryColor
  }), '> span', {
    color: legendColor
  }), "& ".concat(InputTypographyStyled), {
    '& input::placeholder': {
      color: primaryColor
    }
  })), "".concat(inputAction).concat(State.Hover), {
    fill: primaryColor
  })), experiments.iconsMigrationToV3 ? "button".concat(State.FocusedWithin, " > .").concat(ICON_CONTAINER_CLASS).concat(inputAction) : "button".concat(State.FocusedWithin, " > ").concat(IconStyled).concat(inputAction), {
    fill: primaryColor
  }), "&".concat(State.Pressed), _defineProperty({
    '& fieldset': {
      borderColor: primaryColor
    }
  }, "& ".concat(LabelStyled, " > ").concat(TypographyStyled), {
    color: primaryColor
  })));
};
var dropdownInteractiveState = function dropdownInteractiveState(experiments, theme, interactive) {
  var primaryColor = selectToken(theme.background, 'product.primary');
  var legendColor = selectToken(theme.text, 'base.subtle');
  var baseInputInteractiveState = inputInteractiveState(experiments, theme, interactive);
  return _objectSpread(_objectSpread({}, baseInputInteractiveState), {}, _defineProperty({}, "&".concat(State.FocusedWithin), _defineProperty(_defineProperty(_defineProperty({}, "& ".concat(LabelStyled), _objectSpread({
    opacity: 0,
    transition: 'opacity 0.3s'
  }, interactive && {
    '& > p': {
      color: primaryColor
    }
  })), '& fieldset', _objectSpread({}, interactive && {
    borderColor: primaryColor
  })), '> span', {
    color: legendColor
  })));
};

export { dropdownInteractiveState, inputInteractiveState };
//# sourceMappingURL=inputInteractiveState.js.map
